module.exports = __webpack_public_path__ + "img/icn-fishing-checked.9621c51d.png";